import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { CommonFunctionalitiesService } from '@app/services/common-functionalities.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Sort } from '@angular/material/sort';
import { TitleService } from '@app/services/title.service';
import { Messages } from '@app/util/messages.util';
import { Messages as msg } from '@app/util/messages';
import { DatePipe } from '@angular/common';
import { TourGuideContent } from '@app/util/tour-guide-content.util';
import { ConstantsService } from '@app/services/constants.service';
import { ErrorDiagnosticsService } from '@app/services/error-diagnostics.service';
import { ToastService } from '@app/services/toast.service';
import { WfQueueManagerService } from '@app/services/wf-queue-manager.service';
import { TourGuideService } from '@app/services/tour-guide.service';
import { AuthService } from '@app/services/auth/auth.service';
import { Router } from '@angular/router';
import { WorkflowDataSorter } from './workflow-data-sorter';

@Component({
  selector: 'app-table-expandable',
  templateUrl: './table-expandable.component.html',
  styleUrls: ['./table-expandable.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class TableExpandableComponent implements OnChanges, AfterViewInit {

  /****************** Variable declaration ******************/
  refreshIcon = Messages.refreshIcon;
  tourId = TourGuideContent;
  getNoData = msg.no_data; //for getting no data available message
  accessMsg = msg.permissionMsg
  /* Hover titles */
  expandIcon = this.titleService.expandIcon;
  collapseIcon = this.titleService.collapseIcon;
  saveIcon = this.titleService.saveIcon;
  cancelIcon = this.titleService.cancelIcon;
  editIcon = this.titleService.saveIcon;
  deleteIcon = this.titleService.cancelIcon;
  openInNewIcon = this.titleService.openInNewIcon;
  errorDignoColumnHeaders = ['GitHub username', 'Number of times error occured (per week)']
  errorDignoColumnsToDisplay = ['gmId', 'count', 'empty'];
  errorDignoexpandDataSource: any = [];
  queueData: any = []
  sorter: WorkflowDataSorter = new WorkflowDataSorter();

  /****************** View child ******************/
  @ViewChild(MatPaginator) paginator: MatPaginator;

  /****************** Input and Output decorators ******************/
  @Input() dataSource: any;
  @Input() columnHeaders: any;
  @Input() columnsToDisplay: any;
  @Input() columnsToDisplayWithExpand: any;
  @Input() expandedElement: any = null;
  @Input() expandOption: string | undefined;
  @Input() duration: any;
  @Input() wfId: any = 0;
  @Input() rowData!: string[];
  @Input() errorDignostic: any
  @Input() enableClass: any;
  @Input() adjustDuration: any = false;
  @Input() workflowPageObj: any;
  @Output() refreshClickEvent = new EventEmitter<any>();
  @Output() storeSelectedElement = new EventEmitter<any>();


  /**
   * constructor
   * @param cf 
   * @param titleService 
   * @param datePipe 
   * @param constantsService
   * @param errorDignosticService
   * @param  wfQueueService
   * @param ts
   * @param tourGuideService
   */
  constructor(public cf: CommonFunctionalitiesService,
    public titleService: TitleService,
    private datePipe: DatePipe,
    public constantsService: ConstantsService,
    private errorDignosticService: ErrorDiagnosticsService,
    private wfQueueService: WfQueueManagerService,
    public ts: ToastService,
    public tourGuideService: TourGuideService,
    public authService: AuthService,
    private router: Router,) {
  }

  /**check if datasource contains any data or not */
  isDataSourceEmpty(): boolean {
    return !this.dataSource.data || this.dataSource.data.length === 0 || this.dataSource.data == null;
  }

  /** get time format */
  getTimeFormat(t: any) {
    // Convert backend date to JavaScript Date object
    const jsDate = new Date(t);

    // Format the date using DatePipe
    const formattedDate = this.datePipe.transform(jsDate, 'MMMM d, yyyy HH:mm');
    return formattedDate;
  }

  /** Refreshes the whole page */
  refresh(): void {
    this.refreshClickEvent.emit()
  }

  /** ngOnChages */
  ngOnChanges() {
    this.dataSource = new MatTableDataSource<any>(this.dataSource instanceof MatTableDataSource ? this.dataSource.data : this.dataSource);
    this.dataSource.paginator = this.paginator;
  }

  /** ngAfterViewInit */
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  /**
  * openInNewTab will trigger and open a new tab in which user will be able to view
  * the github actions
  * @param row 
  */
  openInNewTab(row: any) {
    if (row?.actionsUrl) {
      window.open(row?.actionsUrl);
    }
    return false
  }

  /**on expand functionality for error diagnostics */
  onExpand(element: any) {
    if (this.workflowPageObj?.isworkflowPage) return;

    this.expandedElement = this.expandedElement === element ? null : element

    /**wfQueueManager expand */
    /**set the current page to 0 everytime a row is expanded */
    this.wfQueueService.currentPage = 0;
    /**set sorted data to null everytime a row is expanded */
    this.wfQueueService.sortedData = null;

    if (this.expandOption === 'errorDignostic' && this.expandedElement) {
      this.errorDignosticApi(element.keyword)
    }
  }

  /**error diagnostics api call */
  errorDignosticApi(keyword: number) {
    this.errorDignosticService.getErrorDignosticUsers(keyword, this.errorDignostic.week).subscribe((response: any) => {
      this.errorDignoexpandDataSource = response.data.dbResp
    })
  }

  /**
   * reRunWorkflow is used to re trigger the executed workflows with the same configurations
   * @param element 
   */
  reRunWorkflow(element: any) {
    if (this.tourGuideService.isStartTour) {
      this.ts.showSuccess(Messages.success, Messages.manualWfTrigger.reRunSuccess);
    } else {
      //Check for access
      if (!this.authService.permissions['rerun-workflow']) return;

      this.wfQueueService.reRunExisitingWf(element.jobId).subscribe((resp: any) => {
        this.ts.showSuccess(Messages.success, Messages.manualWfTrigger.reRunSuccess);
      }, (error: any) => {
        this.ts.showError(Messages.error, Messages.manualWfTrigger.reRunFail);
      })
    }
  }

  /**queuedData */
  queuedData($event: any) {
    this.queueData = $event
  }

  /**
   * formats number to compact number
   * like 1000 will be formatted to 1k
   * @param num any number
   * @returns formatted number
   */
  formatNumber(num: number | bigint) {
    return this.cf.compactNumberFormatter.format(num);
  }
  /**
 * handler which handles click on view button
 * @param workflow workflow row
 */
  onView(workflow: any) {
    this.router.navigate(['/workflow-run', workflow.wfId]);
  }

  /**
   * sorts data in ascending or descending order
   * @param sort info of column to sort
   */
  sortData(sort: Sort) {
    if (sort.direction == '') {
      sort.active = 'wfName'
      sort.direction = 'asc'
    }
    this.sorter.dataSource = this.dataSource.data.slice();
    this.sorter.column = sort.active;
    this.sorter.asc = sort.direction === "asc";
    this.dataSource.data = this.sorter.sort();
  }

  /**repoUrl modification */
  format(str: any) {
    if (isNaN(str) && str?.startsWith('github.com/')) {
      return str.substring('github.com/'.length);
    } else {
      return str
    }
  }
}
